import React from 'react';
import TextFilter from 'components/list/Filters/types/TextFilter';

const LastNameFilter = <TextFilter
    label='filters.components.lastName.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='last_name'
/>;

export default LastNameFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/LastNameFilter.js